// extracted by mini-css-extract-plugin
export default {"idTypeSelector":"onfido-sdk-ui-Capture-IdTypeSelector-idTypeSelector"};